export const RatingsMock = [
  {
    action_company: 'Downgrades',
    action_pt: 'Lowers',
    adjusted_pt_current: '78.00',
    adjusted_pt_prior: '110.00',
    analyst: 'Piper Sandler',
    analyst_name: 'Alexander Potter',
    currency: 'USD',
    cusip: 'G6095L109',
    date: '2019-01-25',
    exchange: 'NYSE',
    id: '5c4aff3888f7d40001ada319',
    importance: 5,
    isin: 'JE00B783TY65',
    name: 'Aptiv',
    notes: '',
    pt_current: '78.00',
    pt_prior: '110.00',
    rating_current: 'Neutral',
    rating_prior: 'Overweight',
    ticker: 'APTV',
    time: '07:21:12',
    updated: 1549697519,
    url: 'https://www.benzinga.com/stock/APTV/ratings',
    url_calendar: 'https://www.benzinga.com/stock/APTV/ratings',
    url_news: 'https://www.benzinga.com/stock-articles/APTV/analyst-ratings',
  },
  {
    action_company: 'Maintains',
    action_pt: 'Raises',
    adjusted_pt_current: '34.00',
    adjusted_pt_prior: '30.00',
    analyst: 'Citigroup',
    analyst_name: 'PJ Juvekar',
    currency: 'USD',
    cusip: '59151K108',
    date: '2016-10-04',
    exchange: 'NASDAQ',
    id: '57f3bc084309aa5f01454eed',
    importance: 3,
    isin: 'CA59151K1084',
    name: 'Methanex',
    notes: '',
    pt_current: '34.00',
    pt_prior: '30.00',
    rating_current: 'Neutral',
    rating_prior: '',
    ticker: 'MEOH',
    time: '09:59:43',
    updated: 1475591204,
    url: 'https://www.benzinga.com/stock/MEOH/ratings',
    url_calendar: 'https://www.benzinga.com/stock/MEOH/ratings',
    url_news: 'https://www.benzinga.com/stock-articles/MEOH/analyst-ratings',
  },
  {
    action_company: 'Maintains',
    action_pt: 'Lowers',
    adjusted_pt_current: '17.00',
    adjusted_pt_prior: '22.00',
    analyst: 'Keybanc',
    analyst_name: 'Brett Andress',
    currency: 'USD',
    cusip: '81282V100',
    date: '2016-08-08',
    exchange: 'NYSE',
    id: '57a890ca4309aa12eb350f99',
    importance: 3,
    isin: 'US81282V1008',
    name: 'SeaWorld Entertainment',
    notes: '',
    pt_current: '17.00',
    pt_prior: '22.00',
    rating_current: 'Overweight',
    rating_prior: '',
    ticker: 'SEAS',
    time: '09:50:34',
    updated: 1470664931,
    url: 'https://www.benzinga.com/stock/SEAS/ratings',
    url_calendar: 'https://www.benzinga.com/stock/SEAS/ratings',
    url_news: 'https://www.benzinga.com/stock-articles/SEAS/analyst-ratings',
  },
  {
    action_company: 'Initiates Coverage On',
    action_pt: 'Announces',
    adjusted_pt_current: '100.00',
    adjusted_pt_prior: '',
    analyst: 'Maxim Group',
    currency: 'USD',
    cusip: '399473107',
    date: '2016-06-23',
    exchange: 'NASDAQ',
    id: '576b9e944309aa5299758f17',
    importance: 3,
    isin: 'US3994732069',
    name: 'Groupon',
    notes: '',
    pt_current: '5.00',
    pt_prior: '',
    rating_current: 'Buy',
    rating_prior: '',
    ticker: 'GRPN',
    time: '04:28:11',
    updated: 1606296967,
    url: 'https://www.benzinga.com/stock/GRPN/ratings',
    url_calendar: 'https://www.benzinga.com/stock/GRPN/ratings',
    url_news: 'https://www.benzinga.com/stock-articles/GRPN/analyst-ratings',
  },
  {
    action_company: 'Initiates Coverage On',
    action_pt: 'Announces',
    adjusted_pt_current: '41.00',
    adjusted_pt_prior: '',
    analyst: 'Barclays',
    analyst_name: 'Steve Valiquette',
    currency: 'USD',
    cusip: '74051N102',
    date: '2016-06-01',
    exchange: 'NASDAQ',
    id: '574e941e4309aa164923b1b5',
    importance: 3,
    isin: 'US74051N1028',
    name: 'Premier',
    notes: '',
    pt_current: '41.00',
    pt_prior: '',
    rating_current: 'Overweight',
    rating_prior: '',
    ticker: 'PINC',
    time: '03:48:27',
    updated: 1464752907,
    url: 'https://www.benzinga.com/stock/PINC/ratings',
    url_calendar: 'https://www.benzinga.com/stock/PINC/ratings',
    url_news: 'https://www.benzinga.com/stock-articles/PINC/analyst-ratings',
  },
  {
    action_company: 'Upgrades',
    action_pt: 'Raises',
    adjusted_pt_current: '90.00',
    adjusted_pt_prior: '83.00',
    analyst: 'Citigroup',
    analyst_name: 'Kate McShane',
    currency: 'USD',
    cusip: '548661107',
    date: '2016-05-20',
    exchange: 'NYSE',
    id: '573ee3324309aa140ff0730d',
    importance: 3,
    isin: 'US5486611073',
    name: "Lowe's Companies",
    notes: '',
    pt_current: '90.00',
    pt_prior: '83.00',
    rating_current: 'Buy',
    rating_prior: 'Neutral',
    ticker: 'LOW',
    time: '06:03:37',
    updated: 1463724217,
    url: 'https://www.benzinga.com/stock/LOW/ratings',
    url_calendar: 'https://www.benzinga.com/stock/LOW/ratings',
    url_news: 'https://www.benzinga.com/stock-articles/LOW/analyst-ratings',
  },
  {
    action_company: 'Initiates Coverage On',
    action_pt: '',
    analyst: 'CLSA',
    currency: 'USD',
    cusip: '655844108',
    date: '2016-05-19',
    exchange: 'NYSE',
    id: '573da7bd4309aa140ff0720d',
    importance: 3,
    isin: 'US6558441084',
    name: 'Norfolk Southern',
    notes: '',
    pt_current: '',
    pt_prior: '',
    rating_current: 'Outperform',
    rating_prior: '',
    ticker: 'NSC',
    time: '07:43:51',
    updated: 1463643831,
    url: 'https://www.benzinga.com/stock/NSC/ratings',
    url_calendar: 'https://www.benzinga.com/stock/NSC/ratings',
    url_news: 'https://www.benzinga.com/stock-articles/NSC/analyst-ratings',
  },
  {
    action_company: 'Initiates Coverage On',
    action_pt: '',
    analyst: 'CLSA',
    currency: 'USD',
    cusip: '485170302',
    date: '2016-05-19',
    exchange: 'NYSE',
    id: '573da7a94309aa140ff0720c',
    importance: 3,
    isin: 'US4851703029',
    name: 'Kansas City Southern',
    notes: '',
    pt_current: '',
    pt_prior: '',
    rating_current: 'Underperform',
    rating_prior: '',
    ticker: 'KSU',
    time: '07:43:35',
    updated: 1463643815,
    url: 'https://www.benzinga.com/stock/KSU/ratings',
    url_calendar: 'https://www.benzinga.com/stock/KSU/ratings',
    url_news: 'https://www.benzinga.com/stock-articles/KSU/analyst-ratings',
  },
  {
    action_company: 'Upgrades',
    action_pt: '',
    analyst: 'Seaport Global',
    currency: 'USD',
    cusip: '78469X107',
    date: '2016-05-05',
    exchange: 'NYSE',
    id: '572b44dd4309aa0d6c1be60d',
    importance: 3,
    isin: 'US78469X1072',
    name: 'SPX FLOW',
    notes: '',
    pt_current: '',
    pt_prior: '',
    rating_current: 'Buy',
    rating_prior: 'Accumulate',
    ticker: 'FLOW',
    time: '09:00:20',
    updated: 1462438820,
    url: 'https://www.benzinga.com/stock/FLOW/ratings',
    url_calendar: 'https://www.benzinga.com/stock/FLOW/ratings',
    url_news: 'https://www.benzinga.com/stock-articles/FLOW/analyst-ratings',
  },
  {
    action_company: 'Upgrades',
    action_pt: '',
    adjusted_pt_current: '',
    adjusted_pt_prior: '',
    analyst: 'Piper Sandler',
    analyst_name: 'Kevin Barker',
    currency: 'USD',
    cusip: '14040H105',
    date: '2016-04-27',
    exchange: 'NYSE',
    id: '5720ac1b4309aa75e14a5687',
    importance: 3,
    isin: 'US14040H1059',
    name: 'Capital One Financial',
    notes: '',
    pt_current: '',
    pt_prior: '',
    rating_current: 'Buy',
    rating_prior: 'Hold',
    ticker: 'COF',
    time: '08:07:46',
    updated: 1461744466,
    url: 'https://www.benzinga.com/stock/COF/ratings',
    url_calendar: 'https://www.benzinga.com/stock/COF/ratings',
    url_news: 'https://www.benzinga.com/stock-articles/COF/analyst-ratings',
  },
];
